// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1aPuT","footer":"ModalUpdate_footer__3WLws"};